import { useEffect, useRef, useState } from 'react';

export default function TicketThread({ api, ticketId, onSent }) {
  const [ticket, setTicket] = useState(null);
  const [messages, setMessages] = useState([]);
  const [reply, setReply] = useState('');
  const [sending, setSending] = useState(false);
  const bottomRef = useRef(null);

  function load() {
    api.get(`/tickets/${ticketId}/messages`).then(({ data }) => {
      setTicket(data.ticket);
      setMessages(data.messages);
    });
  }

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ticketId]);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  async function sendReply(e) {
    e.preventDefault();
    if (!reply.trim()) return;
    setSending(true);
    try {
      await api.post(`/tickets/${ticketId}/messages`, { body: reply });
      setReply('');
      load();
      onSent?.();
    } finally {
      setSending(false);
    }
  }

  if (!ticket) return <div className="p-4 text-sm text-gray-500">Loading...</div>;

  return (
    <div className="flex flex-col h-full">
      <div className="px-4 py-2 border-b border-gray-100">
        <p className="text-sm font-medium text-gray-900">{ticket.subject}</p>
      </div>

      <div className="flex-1 overflow-y-auto p-4 space-y-3">
        {messages.map((m) => (
          <div key={m.id} className={`flex ${m.sender_type === 'customer' ? 'justify-end' : 'justify-start'}`}>
            <div
              className={`max-w-[80%] rounded-2xl px-3 py-2 text-sm ${
                m.sender_type === 'customer' ? 'bg-grey-700 text-white' : 'bg-pampa-100 text-gray-900'
              }`}
            >
              {m.body}
            </div>
          </div>
        ))}
        <div ref={bottomRef} />
      </div>

      <form onSubmit={sendReply} className="p-3 border-t border-gray-200 flex gap-2">
        <input
          className="input-field flex-1"
          value={reply}
          onChange={(e) => setReply(e.target.value)}
          placeholder="Type a reply..."
        />
        <button type="submit" className="btn-primary" disabled={sending}>
          Send
        </button>
      </form>
    </div>
  );
}
